// @ts-expect-error import a model from an external library
import { ErrorModel } from '@health/booking-sdk-react/dist/services/bb-booking/models'
import { apiBaseUrl } from 'app/src/msw/commonconfig'
import type { newsApi } from 'app/src/services/welfareportal'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { mockNews } from './mocknews'

const carabinieriNews = {
  items: [
    {
      title: 'Il Catalogo delle convenzioni PWSxTe',
      id: '6',
      date: '2025-09-15',
      content:
        'Le nostre collaborazioni con i partner commerciali più prestigiosi ci consentono di ottenere sempre le condizioni migliori per i nostri aderenti. \nGrazie ai nostri numerosi anni di esperienza in ambito welfare siamo in grado di offrire sconti importanti grazie ai partner presenti nel nostro portale dedicato.\nCollaboriamo con i marchi più rinomati che ci mettono a disposizione un ampio ventaglio di offerte vantaggiose, in tutte le categorie merceologiche. Il nostro punto di forza è rappresentato dalla capacità di anticipare gli sviluppi del mercato e di inserire nel nostro catalogo prodotti di qualità.',
    },
    {
      title: 'La piattaforma dedicata alle esigenze degli utenti',
      id: '7',
      date: '2025-09-15',
      content:
        'La piattaforma è costruita anche in base all’ascolto delle esigenze delle aziende e dei loro dipendenti: offre un’esperienza di navigazione nuova, facile, evoluta e digitalizzata per avere accesso a scontistiche dedicate su una ampia selezione di prodotti e servizi, grazie ad accordi con partner convenzionati. \nLa piattaforma Poste Mondo Welfare è facile da usare, intuitiva e agile, per migliorare l’uso del programma e per facilitare la scelta delle opportunità offerte, perché anche la semplicità conferma il valore delle nostre scelte.\nI nostri utenti possono accedervi da qualsiasi dispositivo, anche mobile. E’ possibile personalizzare l’interfaccia con il logo e le linee guida dell’azienda mettendo a disposizione tutte le convenzioni a Catalogo.',
    },
    {
      title: 'La semplicità di scegliere',
      id: '8',
      date: '2025-09-15',
      content:
        'Sarà sufficiente individuare l’opportunità di proprio interesse e con pochi click, selezionare e ottenere il prodotto/servizio scontato presente all’interno di ciascuna categoria messa a disposizione dalle convenzioni aziendali (es: Moda, Spese socioassistenziali, Spese trasporti, Cultura, Sport, Tempo libero, Viaggi e vacanze, Salute e Family Care, Cura della persona). \nCliccando su ogni categoria è possibile visualizzare il dettaglio delle opzioni e le modalità di utilizzo presenti in essa. \nIn base alla scelta effettuata si potrà usufruire delle scontistiche ottenute negli shop online e presso i negozi o i centri fisici facilmente raggiungibili anche grazie ad un servizio di geo-localizzazione.',
    },
  ],
  paging: {
    limit: 10,
    offset: 0,
    total: 3,
  },
}

export const getNewsPaginated = http.get<{ templateId: string }, DefaultBodyType, newsApi.NewsPaginated>(
  apiBaseUrl + '/:templateId/pages/news',
  async (req) => {
    const templateId = (req.params as { templateId: string }).templateId
    const url = new URL(req.request.url)
    const offset = Number.parseInt(url.searchParams.get('pagingOffset') ?? '0')
    const limit = Number.parseInt(url.searchParams.get('pagingLimit') ?? '5')
    const items = mockNews.slice(offset, offset + limit)?.map((item) => ({ ...item, title: `${item.title} - ${item.id}` }))
    switch (templateId) {
      case 'DEFAULT':
        return HttpResponse.json({
          items,
          paging: {
            limit,
            offset,
            total: mockNews.length,
          },
        })
      case 'CARABINIERI':
        return HttpResponse.json(carabinieriNews)
      default: {
        const result = {
          status: 404,
          type: 'urn:NewsNotFound',
          title: 'news not found',
          rc: 42404,
        } as ErrorModel
        return HttpResponse.json(result, { status: 404 })
      }
    }
  },
)

export const getSingleNews = http.get<{ id: string }, DefaultBodyType, newsApi.News | object>(
  apiBaseUrl + '/news/:id',
  async ({ params }) => {
    const { id } = params
    const mockItem = mockNews[Number(id) - 1] || carabinieriNews.items.find((value) => value.id === id)
    // mockItem.id = id
    // mockItem.title = `${mockItem.title}-${id}`
    return id === 'NOTFOUND'
      ? HttpResponse.json({ rc: 'III', type: 'not' }, { status: 404, statusText: 'Nada' })
      : HttpResponse.json(mockItem)
  },
)

export const newsHandlers = [getNewsPaginated, getSingleNews]
